import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { key } from 'styled-theme';
import Svg from '@sizeid/commons/components/SvgImage/styled/Svg';
import { media } from '@sizeid/commons/utils/styles';

import TooltipContainer from 'components/Tooltip/styled/TooltipContainer';

import Input, { Textarea } from './Input';

export default styled.div<{ noIcon?: boolean }>`
  position: relative;

  ${media.moreThan('480px')`
    display: inline-block;
  `};

  > ${Input}, > ${Textarea} {
    display: block;
    width: 100%;
    padding-left: ${ifProp('noIcon', '20px', '50px')};
  }

  > ${Svg}, > ${TooltipContainer} {
    position: absolute;
    top: 17px;
  }

  > ${Svg} {
    left: 20px;
    stroke: ${key('colors.black.light[300]')};
    fill: ${key('colors.black.light[300]')};
  }

  > ${TooltipContainer} {
    right: 20px;
  }
`;
